import payrollSystem_0 from "../../images/projects/payrollSystem/0.PNG";
import payrollSystem_1 from "../../images/projects/payrollSystem/1.PNG";
import payrollSystem_2 from "../../images/projects/payrollSystem/2.PNG";
import payrollSystem_3 from "../../images/projects/payrollSystem/3.PNG";
import payrollSystem_4 from "../../images/projects/payrollSystem/4.PNG";

export default function payrollSystemImages() {
  return [
    payrollSystem_0,
    payrollSystem_1,
    payrollSystem_2,
    payrollSystem_3,
    payrollSystem_4,
  ];
}